import { useTranslations } from 'next-intl'

import { RoomThumbnail, TRoomDetail } from '@/entities/room'
import { Link } from '@/shared/i18n'
import { cn } from '@/shared/lib'
import { TextButton } from '@/shared/ui'

import { SubHeading } from '../../common'
import { RoomDrawerTrigger } from '../room-drawer'

const MAX_OTHER_HOST_ROOMS = 6

type Props = Pick<TRoomDetail, 'otherHostRooms'>

export const MobileOtherRooms = ({
  otherHostRooms: otherHostRoomsProp,
}: Props) => {
  const t = useTranslations('room_detail')

  const otherHostRooms = otherHostRoomsProp.slice(0, MAX_OTHER_HOST_ROOMS)

  const isMoreThanMaxOtherHostRooms =
    otherHostRoomsProp.length > MAX_OTHER_HOST_ROOMS

  if (otherHostRooms.length === 0) {
    return null
  }

  return (
    <div>
      <div className="mb-3 flex items-center justify-between">
        <SubHeading className="typo-body2">
          {t('landlord_profile.other_unit')}
        </SubHeading>
        {isMoreThanMaxOtherHostRooms && (
          <RoomDrawerTrigger otherHostRooms={otherHostRoomsProp}>
            <TextButton color="gray" weight="normal" size="small">
              {t('landlord_profile.button.view_all')}
            </TextButton>
          </RoomDrawerTrigger>
        )}
      </div>

      <RoomList otherHostRooms={otherHostRooms} />
    </div>
  )
}
type RoomListProps = Pick<TRoomDetail, 'otherHostRooms'>

export const RoomList = ({ otherHostRooms }: RoomListProps) => {
  const t = useTranslations('room_detail')

  return (
    <ul
      className={cn(
        'md:grid md:grid-cols-3 md:gap-x-5 md:gap-y-4',
        'scrollbar-hide -mr-5 flex gap-x-3 overflow-x-auto pr-5',
      )}
    >
      {otherHostRooms.map(room => (
        <li key={room.rid} className="w-[113px] shrink-0 md:w-[84px]">
          <Link href={`/guest/room/${room.rid}`} className="block space-y-2">
            <RoomThumbnail
              src={room.picMain}
              alt={t('landlord_profile.unit_image', {
                roomName: room.roomName,
              })}
              ratio="4:3"
              size={84}
              rounded
              style={{ width: '100%' }}
              imageStyle={{ width: '100%' }}
            />
            <h4 className="typo-label2 line-clamp-1 font-normal text-gray-900">
              {room.roomName}
            </h4>
          </Link>
        </li>
      ))}
    </ul>
  )
}
